export default __webpack_public_path__ + "static/media/list.65685773.svg";